export class SoapLive {
    // staff
    live;
    tabs;

    constructor() {
        this.init();
    }

    init() {
        this.live = $('.soap-live');
        this.tabs = this.live.find('.section-header__tabs');

        if (!this.live.length) {
            return;
        }

        this.bindSoapLiveEvents();
    }

    // fn's
    bindSoapLiveEvents() {
        this.live.on('click', '.soap-live__message__close-button', () => this.closeMessage());
    }

    closeMessage() {
        this.live.find('.soap-live__message').remove();
    }
}
